import React, { useState, Component } from 'react';
import { Button } from './ui/Button';
import { Mail, MapPin, Phone, Send, CheckCircle } from 'lucide-react';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = `New Consultation Request from ${formData.name}`;
    const body = `Name: ${formData.name}
Company: ${formData.company}
Email: ${formData.email}

Project Details:
${formData.message}`;
    // Try to open mailto link
    const mailtoLink = `mailto:parker@plastices.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
    // Show confirmation
    setSubmitted(true);
    // Reset after 15 seconds
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        company: '',
        email: '',
        message: ''
      });
    }, 15000);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.id]: e.target.value
    }));
  };
  return <section id="contact" className="py-24 bg-neutral-50" data-id="element-87">
      <div className="container mx-auto px-4 md:px-6" data-id="element-88">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24" data-id="element-89">
          {/* Left: Contact Info */}
          <div data-id="element-90">
            <span className="text-accent font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-91">
              Get in Touch
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-92">
              Ready to Start Your Project?
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-93">
              Whether you need a quote for a new mold, have questions about
              material selection, or want to discuss our medical manufacturing
              capabilities, dietary and food packaging solutions, we're here to
              help.
            </p>

            <div className="space-y-6" data-id="element-94">
              <div className="flex items-start gap-4" data-id="element-95">
                <div className="p-3 bg-white rounded-lg text-accent shadow-sm shrink-0" data-id="element-96">
                  <MapPin className="h-6 w-6" data-id="element-97" />
                </div>
                <div data-id="element-98">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-99">Location</h3>
                  <p className="text-gray-600" data-id="element-100">
                    Based in Saratoga Springs, Utah
                    <br data-id="element-101" />
                    Serving Clients Nationwide
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-102">
                <div className="p-3 bg-white rounded-lg text-accent shadow-sm shrink-0" data-id="element-103">
                  <Phone className="h-6 w-6" data-id="element-104" />
                </div>
                <div data-id="element-105">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-106">Call Us</h3>
                  <p className="text-gray-600 mb-1" data-id="element-107">
                    Mon-Fri from 8am to 5pm MST
                  </p>
                  <a href="tel:+18016186677" className="text-primary font-medium hover:text-accent transition-colors" data-id="element-108">
                    (801) 618-6677
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-109">
                <div className="p-3 bg-white rounded-lg text-accent shadow-sm shrink-0" data-id="element-110">
                  <Mail className="h-6 w-6" data-id="element-111" />
                </div>
                <div data-id="element-112">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-113">Email Us</h3>
                  <p className="text-gray-600 mb-1" data-id="element-114">
                    Send us your CAD files for a quick quote
                  </p>
                  <a href="mailto:parker@plastices.com" className="text-primary font-medium hover:text-accent transition-colors" data-id="element-115">
                    parker@plastices.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Contact Form */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100" data-id="element-116">
            <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-117">
              Request a Consultation
            </h3>

            {submitted ? <div className="py-12 text-center" data-id="element-118">
                <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" data-id="element-119" />
                <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-120">
                  Email Client Opening...
                </h4>
                <p className="text-gray-600 mb-6" data-id="element-121">
                  Your default email app should open with a pre-filled message.
                </p>
                <p className="text-sm text-gray-500 mb-4" data-id="element-122">
                  If it didn't open, you can email us directly at:
                </p>
                <a href="mailto:parker@plastices.com" className="text-primary font-medium hover:text-accent transition-colors text-lg" data-id="element-123">
                  parker@plastices.com
                </a>
              </div> : <form className="space-y-4" onSubmit={handleSubmit} data-id="element-124">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-125">
                  <div className="space-y-2" data-id="element-126">
                    <label htmlFor="name" className="text-sm font-medium text-gray-700" data-id="element-127">
                      Name
                    </label>
                    <input type="text" id="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-accent focus:border-transparent outline-none transition-all" placeholder="John Doe" required data-id="element-128" />
                  </div>
                  <div className="space-y-2" data-id="element-129">
                    <label htmlFor="company" className="text-sm font-medium text-gray-700" data-id="element-130">
                      Company
                    </label>
                    <input type="text" id="company" value={formData.company} onChange={handleChange} className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-accent focus:border-transparent outline-none transition-all" placeholder="Company Name" data-id="element-131" />
                  </div>
                </div>

                <div className="space-y-2" data-id="element-132">
                  <label htmlFor="email" className="text-sm font-medium text-gray-700" data-id="element-133">
                    Email
                  </label>
                  <input type="email" id="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-accent focus:border-transparent outline-none transition-all" placeholder="john@company.com" required data-id="element-134" />
                </div>

                <div className="space-y-2" data-id="element-135">
                  <label htmlFor="message" className="text-sm font-medium text-gray-700" data-id="element-136">
                    Project Details
                  </label>
                  <textarea id="message" rows={4} value={formData.message} onChange={handleChange} className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-accent focus:border-transparent outline-none transition-all resize-none" placeholder="Tell us about your project requirements, materials, and estimated volumes..." required data-id="element-137"></textarea>
                </div>

                <Button type="submit" className="w-full" size="lg" rightIcon={<Send className="h-4 w-4" data-id="element-139" />} data-id="element-138">
                  Send Message
                </Button>

                <p className="text-xs text-center text-gray-500 mt-4" data-id="element-140">
                  This will open your default email client. Alternatively, email
                  us directly at parker@plastices.com
                </p>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}